module.exports = __webpack_public_path__ + "img/coupon_frame2.d2151f92.png";